import { useMemo } from 'react'

import { getBrand } from 'pared/utils/brand'

import { IPropsType as IFeV2ChatBoxPropsType } from '../../../Routes/renderer/feV2ChatBox'

interface IConfig extends Omit<IFeV2ChatBoxPropsType, 'type'> {
  enableChat: boolean
}

const defaultConfig: IConfig = {
  enableChat: false,
  agentType: 'item',
  description: 'Ask about products',
  sendStoreId: false,
}

export default (): IConfig => {
  const brand = getBrand()

  return useMemo(() => {
    switch (brand) {
      case 'sullivans':
      case 'sullivans_nso':
      case 'eddiemerlots':
      case 'eddiemerlots_nso':
        return {
          ...defaultConfig,
          enableChat: true,
          hideFromNonExpoUsers: true,
          disableInputField: false,
        }

      default:
        return defaultConfig
    }
  }, [brand])
}
